import { useEffect } from "react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const MSG = { import: "استيراد الملفات", export: "التصدير", download: "تنزيل الملفات", upload: "إرفاق ورفع الملفات" };
const state = { blocked: [] };
const isBlocked = (a) => state.blocked.includes(a);
const deny = (a) => toast.error(`ليس لديك صلاحية ${MSG[a]} — تواصل مع مالك الحساب`);
const kindOfFile = (name) => (/\.(xlsx|xls|csv|pdf|docx?)$/i.test(name || "") ? "export" : "download");

if (typeof window !== "undefined" && !window.__actionGuard) {
  window.__actionGuard = true;
  const aClick = HTMLAnchorElement.prototype.click;
  HTMLAnchorElement.prototype.click = function guardedClick() {
    if (this.hasAttribute("download")) {
      const k = kindOfFile(this.getAttribute("download"));
      if (isBlocked(k)) return deny(k);
    }
    return aClick.call(this);
  };
  const aDispatch = HTMLAnchorElement.prototype.dispatchEvent;
  HTMLAnchorElement.prototype.dispatchEvent = function guardedDispatch(ev) {
    if (ev?.type === "click" && this.hasAttribute("download")) {
      const k = kindOfFile(this.getAttribute("download"));
      if (isBlocked(k)) { deny(k); return false; }
    }
    return aDispatch.call(this, ev);
  };
  const iClick = HTMLInputElement.prototype.click;
  const fileKind = (inp) => (/xls|csv|spreadsheet/i.test(inp.accept || "") ? "import" : "upload");
  HTMLInputElement.prototype.click = function guardedInputClick() {
    if (this.type === "file" && isBlocked(fileKind(this))) return deny(fileKind(this));
    return iClick.call(this);
  };
  document.addEventListener("click", (e) => {
    const inp = e.target.closest?.('input[type="file"]');
    if (inp && isBlocked(fileKind(inp))) { e.preventDefault(); e.stopPropagation(); deny(fileKind(inp)); return; }
    const a = e.target.closest?.("a[href]");
    if (a && (a.hasAttribute("download") || /download=1|documents\.zip|merged\.pdf/.test(a.href))) {
      const k = a.hasAttribute("download") ? kindOfFile(a.getAttribute("download")) : "download";
      if (isBlocked(k)) { e.preventDefault(); e.stopPropagation(); deny(k); }
    }
  }, true);
  const wPrint = window.print.bind(window);
  window.print = () => (isBlocked("export") ? deny("export") : wPrint());
}

export const ActionGuard = () => {
  const { user } = useAuth();
  const blocked = (user && user.kind !== "employee" && user.kind !== "marketer" && user.action_blocked) || [];
  const key = blocked.join(",");
  useEffect(() => {
    state.blocked = key ? key.split(",") : [];
    const cls = ["import", "export", "download", "upload"].map((a) => `blk-${a}`);
    document.body.classList.remove(...cls);
    state.blocked.forEach((a) => document.body.classList.add(`blk-${a}`));
  }, [key]);
  return null;
};
